import { InjectedSocketIoProps } from 'platform-components/hocs';

import * as constants from './constants';

export const forceCompleteLesson = (
    clesson: { id: number; lesson: { name: string } },
    courseId: number,
    io: InjectedSocketIoProps['io'],
    websocketDomain: string,
    onSuccess?: () => void
    // eslint-disable-next-line max-params
) =>
    <const>{
        type: constants.FORCE_COMPLETE_LESSON,
        clesson,
        courseId,
        io,
        websocketDomain,
        onSuccess,
    };
